// TODO: get rid of nativeFetch abstraction
export const getCurrencyPrice = async (currencyId: string, origin = '', nativeFetch = fetch) => {
	try {
		const res = await nativeFetch(`${origin}/api/coin-data/currency-price?currencyId=${currencyId}`);
		return await res.json();
	} catch (e) {
		console.error('error occurred', e);
		return 0;
	}
};
